import type {
    RefreshCommerceCustomerSessionRequest,
    RefreshCommerceCustomerSessionResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const refreshCommerceCustomerSessionOperation = defineCommerceOperation<
    RefreshCommerceCustomerSessionRequest,
    RefreshCommerceCustomerSessionResponse
>("commerce.customer.refresh-session");
